import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { Spin } from "antd";
import UserAnalytics from "../../UserAnalytics/UserAnalytics";
import { baseUrl } from "../../../constants/api";
import { API_ENDPOINTS } from "../../../constants/endpoints";
import { RootState } from "../../../store";

const ParticipantDetails = () => {
  const { participant_id } = useParams<{ participant_id: string }>();
  const navigate = useNavigate();
  const [participant, setParticipant] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { token } = useSelector((state: RootState) => state.account);

  useEffect(() => {
    const fetchParticipantDetails = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${baseUrl}${API_ENDPOINTS.GET_USER_DETAILS}?user_id=${participant_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (response.data && response.data.data) {
          setParticipant(response.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch participant details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (participant_id && token) {
      fetchParticipantDetails();
    }
  }, [participant_id, token]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-10 w-full h-[calc(100vh-100px)]">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col items-center gap-6 pb-12 pt-6 overflow-x-hidden">
      {participant && (
        <div className="max-w-[1200px] w-full px-5 md:px-10 bg-white rounded-2xl mb-0 pb-4 pt-6 relative mx-auto shadow-sm">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 m-0">{participant.name}</h2>
              <p className="text-gray-500 m-0 mt-1">{participant.designation}</p>
              {participant.reference_id && <p className="text-sm text-gray-400 mt-1 font-medium">HRMS: {participant.reference_id}</p>}
              <div className="flex gap-3 mt-2 text-sm text-gray-500">
                <span>Role: <span className="font-semibold text-gray-700">{participant.role || "User"}</span></span>
                <span>CLI: <span className="font-semibold text-gray-700">{participant.cli_name || "—"}</span></span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors px-3 py-1.5 rounded-lg border-none cursor-pointer font-medium text-sm mt-1"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5" /><polyline points="12 19 5 12 12 5" /></svg>
                Back
              </button>
            </div>
          </div>
        </div>
      )}
      <UserAnalytics />
    </div>
  );
};

export default ParticipantDetails;
